import { FormatHeaderPoundIcon } from './FormatHeaderPoundIcon';

/**
 * author: Austin Andrews
 * id C632F7EE-B560-4FAA-802E-968DAB3EA979
 * name format-header-pound
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/format-header-pound.svg
 * tags
 * - Text / Content / Format 
 */
export const FormatHeadingHashIcon = FormatHeaderPoundIcon;
export default FormatHeadingHashIcon